export default class TermsAndConditions {
    static wrapTables() {
        $('.terms-and-conditions__condition table').wrap('<div class="condition-table-wrapper"></div>');
    }
}